import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { Container, Grid } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";

// Components
import { onFetchBlogs } from "../../store/blogs/action";
import BackdropLoader from "../../components/loading/BackdropLoader";
import BlogCard from "./BlogCard";
import Sidebar from "./sidebar";
import { blogCategoryFilter, sortByKey } from "../../hooks/utilsFn/utilsFn";
import NoBlogsFound from "./NoBlogsFound";

const Blogpage = () => {
  const blogsData = useSelector((state) => state.blogs?.allData);
  const isLoading = useSelector((state) => state.blogs?.loading);

  const [filterLoading, setFilterLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const dispatch = useDispatch();

  const [filteredBlogs, setFilteredBlogs] = useState({
    isFilter: false,
    data: [],
    isDataFound: true
  });
  const canonicalUrl = useMemo(
    () => `https://www.99gift.in${location.pathname}`,
    [location.pathname]
  );

  const dataFilter = async (data, category) => {
    const filteredBlogs = await blogCategoryFilter(data, "categroies", category);

    if (!filteredBlogs?.length) {
      setFilteredBlogs({
        isFilter: true,
        data: [],
        isDataFound: false
      });
    } else {
      const sortedData = sortByKey(filteredBlogs, "updated_at", "desc");
      setFilteredBlogs({
        isFilter: true,
        data: sortedData,
        isDataFound: true
      });
    }
    setFilterLoading(false);
    return;
  }

  useEffect(() => {
    if (!searchParams?.size) {
      setFilteredBlogs({
        isFilter: false,
        data: [],
        isDataFound: true
      });
      setFilterLoading(false);
    } else {
      setFilterLoading(true);
      const category = searchParams.get("category");
      dataFilter(blogsData, category);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!blogsData || blogsData.length === 0) {
      dispatch(onFetchBlogs());
    }
  }, [dispatch, blogsData]);

  return (
    <>
      <BlogMeta canonicalUrl={canonicalUrl} />

      <Container
        maxWidth="xl"
        sx={{
          backgroundColor: "white.main",
          mt: { xs: 2, sm: 4 },
          mb: { md: 4 },
          minHeight: { lg: 400 },
        }}
      >
        {(isLoading || filterLoading) ? (
          <BackdropLoader open={isLoading} />
        ) : (
          <Grid container columnSpacing={4}>
            <Grid item xs={12} md={8}>
                <Grid container rowSpacing={3} columnSpacing={3}
                  sx={{
                    display: "flex",
                    justifyContent:"center"
                  }}
                >
                {filteredBlogs?.isFilter ?
                  (filteredBlogs?.isDataFound ?
                    (filteredBlogs?.data?.map((item) => (<BlogCard data={item} key={item.id} />)))
                    : (<NoBlogsFound />))
                  : (blogsData?.map((item, idx) => {
                    return <BlogCard data={item} key={item?.id} />
                  }))
                }
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              {filteredBlogs?.isFilter ? <Sidebar blogData={filteredBlogs?.data} /> : <Sidebar blogData={blogsData} />}
            </Grid>
          </Grid>
        )}
      </Container>
    </>
  );
};

export default Blogpage;

const BlogMeta = ({ canonicalUrl }) => (
  <Helmet>
    <title>Blogs Regarding Gift Cards - 99gift</title>
    <meta name="description" content="Blogs Regarding Gift Cards - 99gift" />
    <meta property="og:url" content={canonicalUrl} />
    <meta property="og:title" content="Blogs Regarding Gift Cards - 99gift" />
    <meta property="og:description" content="Blogs Regarding Gift Cards - 99gift" />
    <link rel="canonical" href={canonicalUrl} />
  </Helmet>
);
